module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "header-img"
    }
  }, [_c('headerTop', {
    attrs: {
      "baseInfo": _vm.baseInfo,
      "isregister": _vm.isregister,
      "englishpc": _vm.englishpc * 1
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "height": "100%",
      "margin": "0 auto",
      "position": "relative"
    }
  }, [_c('i-header', {
    attrs: {
      "slides": _vm.slides,
      "banner": _vm.url
    }
  })], 1), _vm._v(" "), (false) ? _c('div', {
    staticClass: "info-box",
    class: [_vm.flag1 === 0 || _vm.flag1 === null ? 'bottom' : '']
  }, [_c('div', [_c('p', {
    staticStyle: {
      "width": "619px",
      "font-size": "34px",
      "font-weight": "700",
      "word-spacing": "25px",
      "margin-bottom": "50px"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.baseInfo.cTitle) + "\n      ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_c('span', {
    staticStyle: {
      "vertical-align": "middle"
    }
  }, [_vm._v(_vm._s(_vm.baseInfo.cProvince))]), _vm._v(" "), _c('i', {
    staticStyle: {
      "display": "inline-block",
      "width": "4px",
      "height": "4px",
      "border-radius": "50%",
      "background-color": "#ffffff"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "vertical-align": "middle"
    }
  }, [_vm._v(_vm._s(_vm.baseInfo.cCity))])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "18px",
      "margin-top": "20px",
      "font-weight": "500"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.baseInfo.cStartDt))]), _vm._v(" "), _c('span', [_vm._v("-")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.baseInfo.cEndDt))])])])]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fixed),
      expression: "fixed"
    }],
    ref: "base-bm",
    staticClass: "base-bm",
    style: ({
      right: _vm.fixedPostRight + 'px'
    })
  }, [(_vm.register) ? _c('div', {
    staticClass: "child",
    on: {
      "click": function($event) {
        _vm.login('')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("./imgs/reg.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("message.tpl1.menu.register")))])]) : _vm._e(), _vm._v(" "), (_vm.baseInfo.paperSubmitFl == 1) ? _c('div', {
    staticClass: "child",
    class: {
      disable: _vm.baseInfo.paperSubmitFl == 0
    },
    on: {
      "click": _vm.reg1
    }
  }, [_c('img', {
    attrs: {
      "src": require("./imgs/onlinePaper.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("message.tpl1.menu.paperRegister")))])]) : _vm._e(), _vm._v(" "), (_vm.baseInfo.groupRegisterFl == 1) ? _c('div', {
    staticClass: "child",
    class: {
      disable: _vm.baseInfo.groupRegisterFl == 0
    },
    on: {
      "click": _vm.teamReg
    }
  }, [_c('img', {
    attrs: {
      "src": require("./imgs/teamreg.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("message.tpl1.menu.teamReg")))])]) : _vm._e()])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0572bb20"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tpl1/headerImg/headerImg.vue
// module id = 764
// module chunks = 10